import React, { useCallback } from 'react';
import { TextArea } from '@buoyhealth/common.buoy-input';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import SubmitButton from '../../SubmitButton';

interface MedicationInputProps {
  value: string;
  setValue: (value: string) => void;
  onSubmit: () => void;
  onSkip: () => void;
  isError?: boolean;
}

const MedicationInput: React.FC<MedicationInputProps> = ({
  value,
  setValue,
  onSubmit,
  onSkip,
  isError,
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
    },
    [setValue],
  );

  return (
    <Box
      component="form"
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      width="100%"
    >
      <Grid container spacing={2} className="w-full">
        <Grid item xs={12}>
          <TextArea
            InputProps={{
              sx: { backgroundColor: 'white' },
            }}
            fullWidth
            multiline
            onChange={handleChange}
            value={value}
            placeholder="List medication and supplement names (e.g. Aspirin, atorvastatin, probiotic)"
            className="bp-text-base bp-placeholder-gray-700 bp-placeholder-opacity-100"
            rows="4"
          />
        </Grid>
      </Grid>
      <SubmitButton
        onClick={value ? onSubmit : onSkip}
        text={value && !isError ? 'Next' : 'Skip'}
        errorMessage="I'm sorry, we can't find any medications that match this search. Please try adjusting your query, or press Skip to continue."
        isError={isError}
      />
    </Box>
  );
};

export default MedicationInput;
